import { ArrowSquareOut, X, Article } from '@phosphor-icons/react';

export function ContentDeliverableGrid({ deliverables, onRemove }) {
  if (!deliverables?.length) return null;

  return (
    <div
      className="grid grid-cols-2 lg:grid-cols-3 gap-5"
      data-testid="deliverables-grid"
    >
      {deliverables.map((d) => (
        <div
          key={d.id}
          className="group relative rounded-xl border border-border bg-white overflow-hidden transition-shadow hover:shadow-md"
          data-testid={`deliverable-${d.id}`}
        >
          {/* Remove button — only if onRemove is provided (admin) */}
          {onRemove && (
            <button
              onClick={() => onRemove(d.id)}
              className="absolute right-2 top-2 z-10 flex h-7 w-7 items-center justify-center rounded-full bg-black/60 text-white opacity-0 transition-opacity hover:bg-red-600 group-hover:opacity-100"
              data-testid={`remove-deliverable-${d.id}`}
              title="Remove article"
            >
              <X size={14} weight="bold" />
            </button>
          )}

          {/* Thumbnail */}
          <div className="aspect-[16/9] bg-neutral-100 overflow-hidden">
            {d.image ? (
              <img
                src={d.image}
                alt={d.title}
                className="h-full w-full object-cover"
                onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
              />
            ) : null}
            <div className={`${d.image ? 'hidden' : 'flex'} h-full w-full items-center justify-center bg-neutral-200`}>
              <Article size={36} className="text-neutral-400" />
            </div>
          </div>

          {/* Content */}
          <div className="p-4">
            <h4 className="font-bold text-sm leading-tight mb-1 line-clamp-2">
              {d.title || 'Untitled Article'}
            </h4>
            {d.description && (
              <p className="text-xs text-muted-foreground line-clamp-1 mb-3">
                {d.description}
              </p>
            )}
            <a
              href={d.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-xs font-medium text-primary hover:underline"
              data-testid={`visit-article-${d.id}`}
            >
              <ArrowSquareOut size={14} />
              Visit Article
            </a>
          </div>
        </div>
      ))}
    </div>
  );
}
